// extracted by mini-css-extract-plugin
module.exports = {"alert":"styles_alert__3FOS-"};